import angular = require('angular');
import _ = require('underscore');
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { IClassificationCategoriesValidateComponent } from '../../../../../app.retailer.common/modules/categories/classification-categories-base.component';
import { CategoryListItem } from '../../../../../app.retailer/modules/core';

export interface IChoiceClassificationCategoriesOptions {
    singleSelect: boolean;
    selectedCategories: CategoryListItem[];
    businessType: number;
    isAllSelected: boolean;
    needAllSelect: boolean;
    isOnlyStoreCategories?: boolean;
    getCategoriesTree?: Function;
}

class SelectProductCategory implements ng.IController {
    public static $inject = ['popupService', '$translate'];

    public modalInstance: ng.ui.bootstrap.IModalServiceInstance = this as any;
    public resolve: { options: IChoiceClassificationCategoriesOptions, languageId: number };
    public classificationCategoriesErrors: IClassificationCategoriesValidateComponent;
    public isAllSelected: boolean = false;
    public needAllSelect: boolean = false;
    private startSelectedCategories: CategoryListItem[];

    constructor(private popupService: PopupService, private $translate: angular.translate.ITranslateService) {
    }

    public $onChanges(changes: any) {
        if (changes.resolve) {
            this.startSelectedCategories = this.resolve.options.selectedCategories;
            this.isAllSelected = this.resolve.options.isAllSelected;
            this.needAllSelect = this.resolve.options.needAllSelect;
        }
    }

    public deleteChips = (item: any) => {
        this.resolve.options.selectedCategories = this.resolve.options.selectedCategories.filter((x) => x.CategoryID !== item.CategoryID);
    }

    public changeClassificationCategory(item: any) {
        if (!item.selected) {
            this.resolve.options.selectedCategories = this.resolve.options.selectedCategories.filter((x) => x.CategoryID !== item.ID);
        }
    }

    public select = async () => {

        const selectionResult = {
            status: 'ok',
            isAllSelected: false,
            selectedCategories: [] as CategoryListItem[]
        };

        if (this.isAllSelected) {
            selectionResult.isAllSelected = true;
            this.modalInstance.close({ $value: selectionResult });
        } else {
            selectionResult.selectedCategories = this.resolve.options.selectedCategories;
        }

        this.modalInstance.close({ $value: selectionResult });
    }

    public discard = () => {
        this.modalInstance.dismiss({ $value: { status: 'cancel'} });
    }
}

angular.module('app.retailes.common').component('selectProductCategory', {
    template: require('./select-product-category.component.html'),
    controller: SelectProductCategory,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/shared/select-product-category/select-product-category.component.ts